import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { UserService } from 'src/app/services/user.service';
import { AuthService } from 'src/app/services/auth.service';
import { MatDialog, MatSnackBar } from '@angular/material';
import { Router } from '@angular/router';

@Component({
  selector: 'app-edit-profile',
  templateUrl: './edit-profile.component.html',
  styleUrls: ['./edit-profile.component.css']
})
export class EditProfileComponent implements OnInit {

  user;

  constructor(private userService: UserService, private authService: AuthService, private dialog: MatDialog, private router: Router, private snackBar: MatSnackBar) { }

  ngOnInit() {
    const localUser = localStorage.getItem('user');
    let user = JSON.parse(localUser);

    user.mobile = user.mobile.split('+94')[1];
    this.user = user;
  }

  onUpdateUser(form: NgForm) {

    form.value.mobile = `+94${form.value.mobile}`;

    const data = new FormData();
    data.append('firstName', form.value.firstName);
    data.append('lastName', form.value.lastName);
    data.append('mobile', form.value.mobile);
    data.append('email', form.value.email);

    this.userService.updateUser(data).subscribe(result => {

      this.authService.saveUser(result.data);
      localStorage.setItem('token', result.data.token);
      this.authService.autoAuthUser();

      if (!result.data.verified) {
        this.authService.resendVerification(result.data.mobile);
      }

      let data = {
        name: result.data.name,
        mobile: result.data.mobile,
        email: result.data.email,
        dateOfBirth: result.data.dateOfBirth,
        createdAt: result.data.createdAt,
        addresses: result.data.addresses
      };

      let jsonData = JSON.stringify(data);
      this.userService.setUser(data);

      this.authService.autoAuthUser();
      this.dialog.closeAll();
      this.snackBar.open('Profile updated successfully', 'Dismiss', {
        duration: 3000
      });
    }, error => {
      this.snackBar.open(error.error.data, 'Dismiss', {
        duration: 3000
      });
    });
  }
}
